import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { StatusByRepGridComponent } from '../../components/grids/status-by-rep-grid/status-by-rep-grid.component';
import { BaseAccountInfoComponent } from '../../components/BaseAccountInfo/BaseAccountInfo.component';
import { AccountInfoService } from '../../services/account-info.service';
import { SurveysNeedingApprovalGridComponent } from '../../components/grids/surveys-needing-approval-grid/surveys-needing-approval-grid.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { QueryParamsService } from './../../services/query-params.service';
import moment from 'moment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent 
  extends BaseAccountInfoComponent
  implements OnInit, AfterViewInit {
  @ViewChild(StatusByRepGridComponent) statusByRepGrid: StatusByRepGridComponent;
  @ViewChild(SurveysNeedingApprovalGridComponent) surveysNeedingApprovalGrid: SurveysNeedingApprovalGridComponent;

  dateForm: FormGroup;
  months: { id: number; name: string }[] = [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' },
  ];
  years: number[] = [];
  selectedMonth = 1;
  selectedYear = 2025;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private QueryParamsService: QueryParamsService,
    protected override accountInfoService: AccountInfoService
  ) {
    super(accountInfoService);
  }
  
  areReportsLoading: boolean = false;
  faCircleNotch = faCircleNotch;

  override ngOnInit() {
    super.ngOnInit();

    this.setUpDateForm();
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe((params) => {
      // Save the params for future navigation purposes.
      const queryParams = { ...params['keys'], ...params };
      this.QueryParamsService.setQueryParams(queryParams); // Save the query params in the service for future reference.

      // Handle the month/year stuff.
      const month = parseInt(params['month'], 10);
      if (!isNaN(month)) {
        this.selectedMonth = month;
        this.dateForm.patchValue({
          month: this.selectedMonth,
        });
      }
      const year = parseInt(params['year'], 10);
      if (!isNaN(year)) {
        this.selectedYear = year;
        this.dateForm.patchValue({
          year: this.selectedYear,
        });
      }
      if (isNaN(month) || isNaN(year)) {
        this.setFormDefaults();
      }

      if (this.statusByRepGrid) {
        this.statusByRepGrid.getStatusByRep(this.selectedYear, this.selectedMonth);
      }
    });
  }

  setFormDefaults() {
    // Get the current date
    const currentDate = moment();

    // Extract the month and year
    const currentMonth = currentDate.month() + 1; // e.g., "1"
    const currentMonthYear = currentDate.format('YYYY'); // e.g., "2025"
    this.selectedMonth = currentMonth;
    this.selectedYear = parseInt(currentMonthYear);

    this.dateForm.patchValue({
      month: this.selectedMonth,
      year: this.selectedYear,
    });
  }

  setUpDateForm() {
    const currentYear = new Date().getFullYear();

    for (let year = currentYear; year >= currentYear - 5; year--) {
      this.years.push(year);
    }

    this.dateForm = this.fb.group({
      month: [this.selectedMonth, Validators.required],
      year: [this.selectedYear, Validators.required],
    });
  }

  dateFormOnSubmit() {
    if (this.dateForm.valid) {
      const selectedMonth = this.dateForm.get('month')?.value;
      const selectedYear = this.dateForm.get('year')?.value;
      this.selectedMonth = selectedMonth;
      this.selectedYear = selectedYear;

      if (this.statusByRepGrid) {
        this.statusByRepGrid.getStatusByRep(this.selectedYear, this.selectedMonth);
      }
    }
  }
}
